import { PROJECTS } from "@/data/site";
import Reveal from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import PageHeader, { usePageTitle } from "@/components/PageHeader";

export default function Progetti() {
  usePageTitle("/progetti");
  return (
    <main data-testid="progetti-page">
      <PageHeader
        testId="progetti-header"
        eyebrow="Realizzazioni"
        title="Progetti"
        lead="Una selezione rappresentativa dei nostri interventi, tra impianti civili, industriali e servizi specialistici in tutta Italia."
      />
      <section className="bg-ink">
        <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {PROJECTS.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 120}>
                <article data-testid={`project-card-${p.id}`} className="group relative h-[420px] overflow-hidden rounded-xl border border-white/10">
                  <img src={p.image} alt={p.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-7">
                    <span className="rounded-full border border-brand/30 bg-brand/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-brand">
                      {p.tag}
                    </span>
                    <h3 className="mt-4 font-display text-2xl font-bold uppercase leading-tight text-white">{p.title}</h3>
                    <p className="mt-2 text-xs uppercase tracking-[0.2em] text-white/45">{p.place}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <p className="mt-10 text-xs text-white/40">
            * Immagini rappresentative dei settori di intervento. Portfolio dettagliato disponibile su richiesta.
          </p>
        </div>
      </section>
      <CTASection />
    </main>
  );
}
